import type { Question, QuestionDimension } from '@mentimeter/http-clients';
import type { RatingT } from '@mentimeter/question-modules-types';

interface ScreenReaderTableProps {
  results: RatingT['results'];
  shouldHideResults: boolean;
  range: Question['range'];
  dimensions: QuestionDimension[];
}

export const ScreenReaderTable = ({
  results,
  dimensions,
  range,
  shouldHideResults,
}: ScreenReaderTableProps) => {
  if (shouldHideResults) {
    return <span>Results are currently hidden.</span>;
  }

  return (
    <table lang="en">
      <caption>Results</caption>
      <thead>
        <tr>
          <th>Option</th>
          <th>{`Average ${dimensions[0]?.label} between ${range.min} to ${range.max}`}</th>
          <th>{`Average ${dimensions[1]?.label} between ${range.min} to ${range.max}`}</th>
        </tr>
      </thead>
      <tbody>
        {results.map((result) => {
          return (
            <tr key={result.id}>
              <td>{result.label}</td>
              <td>{(result.score[0] ?? 0).toFixed(1)}</td>
              <td>{(result.score[1] ?? 0).toFixed(1)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
